export default class Objects {
    objects = [
        {
            name: 'cardboard',
            min: 3,
            max: 15,
            identifier: '(',
            model: 'Cardboard',
            static: false
        },
        {
            name: 'pallet',
            min: 1,
            max: 5,
            identifier: ')',
            model: 'Pallet',
            static: false
        },
        {
            name: 'pallet-truck',
            min: 1,
            max: 5,
            identifier: '[',
            model: 'Pallettruck',
            static: false
        },
        // {
        //     name: 'hand-truck',
        //     min: 1,
        //     max: 5,
        //     identifier: ']',
        //     model: 'hand-truck',
        //     static: false
        // },
        {
            name: 'forklift',
            min: 0,
            max: 1,
            identifier: '{',
            model: 'Forklift',
            static: true
        },
        // {
        //     name: 'trolley',
        //     min: 1,
        //     max: 5,
        //     identifier: '}',
        //     model: 'trolley',
        //     static: false
        // },
    ]

    getObjectFromIdentifier(str) {
        return this.objects.find(object => object.identifier === str)
    }

    isObjectCharacter(str) {
        return this.objects.some(object => object.identifier === str)
    }

    getObjectModelFromName(str) {
        return this.objects.find(object => object.name === str).model
    }

    // List all objects 
    getObjects() {
        return this.objects
    }
}